import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "flex items-center"
};
const _hoisted_2 = {
  class: "-mx-2"
};
import { CompetitionPlayerLogQueryOrder } from "@/modules/competitions/services/query-paginator/CompetitionPlayerLogQueryOrder";
import { CompetitionPlayerLog, CupCompetition } from "@/modules/competitions/entity";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import Flag from "@/modules/vue/components/Flag.vue";
import { onBeforeRouteLeave } from "vue-router";
import QueryPaginator from "@/modules/vue/components/QueryPaginator.vue";
import PlayerComponent from "@/modules/team/components/Player.vue";
import CompetitionLogTable from "@/modules/team/pages/players/CompetitionLogTable.vue";
import Talent from "@/modules/youth/components/Talent.vue";
import { Season } from "@/modules/season/entity";
import Submenu from "./Submenu";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerCompetitionLogs',
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const competition = ref();
    const season = ref(([__temp, __restore] = _withAsyncContext(() => Season.current()), __temp = await __temp, __restore(), __temp));
    const query = ref(CompetitionPlayerLog.createQueryBuilder('log').innerJoinAndSelect('log.player', 'player').innerJoinAndSelect('player.country', 'country').innerJoin('log.season', 'season').innerJoin('log.competition', 'competition').where('season.id = :seasonId', {
      seasonId: season.value.id
    }).andWhere('competition.id = :competitionId', {
      competitionId: route.params.id
    }));
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      competition.value = await CupCompetition.createQueryBuilder('competition').innerJoinAndSelect('competition.divisions', 'division').innerJoinAndSelect('competition.country', 'country').innerJoinAndSelect('division.matchdays', 'matchday').innerJoinAndSelect('matchday.division', 'division2').innerJoinAndSelect('matchday.season', 'season').leftJoinAndSelect('matchday.matches', 'match').leftJoinAndSelect('match.homeTeam', 'homeTeam').leftJoinAndSelect('match.awayTeam', 'awayTeam').where('season.id = :seasonId', {
        seasonId: season.value.id
      }).andWhere('competition.id = :competitionId', {
        competitionId: route.params.id
      }).getOneOrFail();
    })), __temp = await __temp, __restore(), __temp);
    onBeforeRouteLeave(watch(() => route.params, refresh));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [competition.value.country ? (_openBlock(), _createBlock(Flag, {
          key: 0,
          country: competition.value.country,
          class: "mr-2"
        }, null, 8, ["country"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(competition.value.name), 1)])]),
        subtitle: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$date(season.value.startDate, 'YYYY')) + "/" + _toDisplayString(_ctx.$date(season.value.endDate, 'YYYY')), 1)]),
        submenu: _withCtx(() => [_createVNode(_unref(Submenu))]),
        default: _withCtx(() => [_createVNode(QueryPaginator, {
          ref: "paginator",
          query: query.value,
          order: _unref(CompetitionPlayerLogQueryOrder)
        }, {
          default: _withCtx(({
            items,
            currentPage,
            perPage
          }) => [_createElementVNode("div", _hoisted_2, [_createVNode(CompetitionLogTable, {
            stats: items,
            "hide-date": "",
            "start-rank": (currentPage - 1) * perPage + 1,
            class: "mt-2"
          }, {
            label: _withCtx(({
              log
            }) => [_createVNode(Talent, {
              talent: log.player.revealedTalent,
              class: "mr-1"
            }, null, 8, ["talent"]), _createVNode(PlayerComponent, {
              player: log.player,
              "hide-constitution": "",
              class: "grow"
            }, null, 8, ["player"])]),
            _: 2
          }, 1032, ["stats", "start-rank"])])]),
          _: 1
        }, 8, ["query", "order"])]),
        _: 1
      });
    };
  }
});